module.exports = __webpack_public_path__ + "img/collage_img_05.f2836034.jpg";